import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SurveyStartComponent } from './components/survey-start/survey-start.component';
import { SurveyCallbackComponent } from './components/survey-callback/survey-callback.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ScreenComponent } from './components/screen/screen.component';

const routes: Routes = [
  { path: 'survey/survey-start', component: SurveyStartComponent },
  { path: 'survey/survey-callback', component: SurveyCallbackComponent },
  {path: 'survey/attempt-survey', component: ScreenComponent},

  // { path: 'notfound', component: NotFoundComponent },
  // { path: '*path', component: NotFoundComponent },
   { path: '**', component: NotFoundComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
